<form [formGroup]="form" class="align-left" [class]="'display-' + displayMode">
  <div class="input-container" style="margin: 0 0 15px 0">
    <label>Are you the Generator?</label>

    <mat-radio-group fxLayout="column" formControlName="isCustomer3rdParty">
      <mat-radio-button
        [tabIndex]="tabIndex"
        [checked]="form.get('isCustomer3rdParty').value === 'no'"
        value="no"
      >
        Yes
      </mat-radio-button>

      <mat-radio-button
        [tabIndex]="tabIndex"
        [checked]="form.get('isCustomer3rdParty').value === 'yes'"
        value="yes"
      >
        No
      </mat-radio-button>

      <mat-error *ngIf="errorHandling('isCustomer3rdParty', 'required')">
        Please select Yes or No
      </mat-error>
    </mat-radio-group>
  </div>

  <div
    class="input-container"
    *ngIf="
      (form.get('isCustomer3rdParty').value === 'yes' ? true : false) ||
      displayMode === 'admin'
    "
    style="margin: 0 0 15px 0"
  >
    <label>
      Do you have 3rd party authorization to sign waste profiles on behalf of
      the generator ?
    </label>

    <mat-radio-group fxLayout="column" formControlName="is3rdPartyAuthorized">
      <mat-radio-button
        [tabIndex]="tabIndex + 1"
        [checked]="form.get('is3rdPartyAuthorized').value === 'yes'"
        value="yes"
      >
        Yes
      </mat-radio-button>

      <mat-radio-button
        [tabIndex]="tabIndex + 1"
        [checked]="form.get('is3rdPartyAuthorized').value === 'no'"
        value="no"
      >
        No
      </mat-radio-button>

      <mat-error *ngIf="errorHandling('is3rdPartyAuthorized', 'required')">
        Please select Yes or No
      </mat-error>
    </mat-radio-group>

    <mat-error
      *ngIf="
        form.value.is3rdPartyAuthorized === 'no' &&
        displayMode === 'admin' &&
        form.value.isCustomer3rdParty === 'yes'
      "
    >
      By selecting No, the waste profile will be sent to the Generator Contact
      on file.
    </mat-error>

    <div class="center-error">
      <mat-error
        *ngIf="
          form.value.is3rdPartyAuthorized === 'no' && displayMode === 'customer'
        "
      >
        By selecting No, the waste profile will be sent to the Generator Contact
        that you will enter on the following page.
      </mat-error>
    </div>
  </div>
</form>
